import { Facebook, Instagram, Youtube, Globe, Linkedin, Twitter } from "lucide-react";

const socialLinks = [
  { id: 1, name: "Facebook", icon: Facebook, url: "https://www.facebook.com/profile.php?id=61572001864009&mibextid=wwXIfr" },
  { id: 2, name: "Instagram", icon: Instagram, url: "https://www.instagram.com/allanimalapp?igsh=MWJyaHNoNmxjbm44ZQ%3D%3D&utm_source=qr" },
  { id: 3, name: "Twitter", icon: Twitter, url: "https://twitter.com/AllAnimalApp" },
  { id: 4, name: "YouTube", icon: Youtube, url: "https://youtube.com/@allanimalapp" },
  { id: 5, name: "LinkedIn", icon: Linkedin, url: "https://www.linkedin.com/company/all-animal-app/" },
  { id: 6, name: "Website", icon: Globe, url: "https://www.allanimalapp.com" },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#4a6e69] text-white">
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4 mb-8">
          <div className="flex items-center gap-3">
            <img
              src="/images/logo.png"
              alt="All Animal App Logo"
              className="w-8 h-8 rounded-full object-cover"
            />
            <span className="text-white font-semibold text-sm">
              All Animal App
            </span>
          </div>

          <p className="text-white/70 text-sm">
            Connecting animals & communities worldwide.
          </p>
        </div>

        <div className="pt-8 border-t border-white/10 text-center">
          <div className="flex items-center justify-center gap-4 mb-4">
            {socialLinks.map((link) => {
              const Icon = link.icon;
              return (
                <a
                  key={link.id}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link.name}
                  className="text-white/70 hover:text-white transition-colors duration-200"
                >
                  <Icon className="w-5 h-5" />
                </a>
              );
            })}
          </div>

          <p className="text-white/50 text-xs">
            © {currentYear} All Animal App™ / CMCI Consulting & Management Group LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
